export const URL_FOR_API = "https://api.hopefunding.com"
 //export const URL_FOR_API = "https://hopefunding-api.42devstudio.com"
 //export const URL_FOR_API = "https://localhost:44397"

 export const SUPPORT_EMAIL = "support@hopefunding.com"
